import { render, staticRenderFns } from "./ServicesMakeup.vue?vue&type=template&id=7c3b9e0c&lang=pug&"
import script from "./ServicesMakeup.vue?vue&type=script&lang=ts&"
export * from "./ServicesMakeup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports